import { gql } from '@apollo/client';

export const GET_PROJECTS = gql`
  query Projects {
    projects {
      id
      name
      org_id
      training_frequency
      target_completion_date
      is_completed
      completed_at
      country {
        id
        name
        countryCode
      }
      source_language {
        id
        name
      }
      target_language {
        id
        name
      }
      document_source_id
      document_source {
        id
        title
        type
        languageId
        copyrightNotice
      }
    }
    getProjectLevels {
      project_id
      project_level
    }
  }
`;
export const DELETE_PROJECT_MUTATION = gql`
  mutation DeleteProject($deleteProjectId: Int!) {
    deleteProject(id: $deleteProjectId)
  }
`;

export const TRIGGER_MACHINE_TRANSLATION_GENERATION_MUTATION = gql`
  mutation TriggerMachineTranslationGeneration($projectId: Int!, $locale: String) {
    triggerMachineTranslationGeneration(projectId: $projectId, locale: $locale) {
      projectId
      status
      assignmentId
      createdAt
    }
  }
`;

export const CREATE_PROJECT_MUTATION = gql`
  mutation CreateProject($project: CreateProjectInput!) {
    createProject(project: $project) {
        id
        name
        org_id
        training_frequency
        source_language {
            id
            name
        }
        target_language {
            id
            name
        }
        country {
            id
            name
            countryCode
        }
        target_completion_date
        is_completed
        completed_at
        document_source_id
        uiLocation
        document_source {
          id
          title
          type
          languageId
          copyrightNotice
      }
    }
  }
`;

export const CREATE_LANGUAGE_MUTATION = gql`
  mutation CreateLanguage($name: String!) {
    createLanguage(name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_PROJECT_MUTATION = gql`
    mutation UpdateProject($id: Int!, $project: UpdateProjectInput!) {
    updateProject(id: $id, project: $project) {
        id
        name
        org_id
        training_frequency
        source_language {
            id
            name
        }
        target_language {
            id
            name
        }
        country {
            id
            name
            countryCode
        }
        document_source_id
        uiLocation
        document_source {
          id
          title
          type
          languageId
          copyrightNotice
        }
        target_completion_date
    }
    }

`;

export const PROJECT_DETAIL_QUERY = gql`
  query ProjectDetail($projectId: Int!) {
    projectDetail(id: $projectId) {
      id
      name
      org_id
      training_frequency
      target_completion_date
      is_completed
      completed_at
      document_source_id
      country {
        id
        name
        countryCode
      }
      source_language {
        id
        name
      }
      target_language {
        id
        name
      }
      uiLocation
    }
  }
`;

export const PROJECT_USERS = gql`
    query ProjectUsersByProjectId($projectId: Int!) {
    projectUsers(projectId: $projectId) {
        id
        project_user_id
        name
        email
        role_id
        role {
        id
        role_type
        }
    }
    }
`;
export const ASSIGNMENT_GROUP = gql`
    query AssignmentGroup($projectId: Int!, $isAdminView: Boolean) {
    assignmentGroup(project_id: $projectId, is_admin_view: $isAdminView) {
        status_group {
          status
          total
        }
        assignment_group {
          level_name
          modules {
            module_name
            assignments {
              id
              name
              assignment_type_id
              has_machine_translation
              user_id
              module_id
              target_completion_date
              status_id
              completed_tasks
              total_tasks
            }
            id
            status_id
            actual_days
            start_date
            end_date
          }
          id
          status_id
        }
      }
    }
`;

export const UPDATE_ASSIGNMENT = gql`
    mutation UpdateAssignmentForProject($assignmentId: Int!, $assignment: UpdateAssignmentInput!) {
        updateAssignment(id: $assignmentId, assignment: $assignment) {
          id
          name
          assignmentTypeId
          userId
          moduleId
          statusId
          targetCompletionDate
        }
    }
`;

export const DISTRIBUTE_ASSIGNMENT = gql`
    mutation DistributeAssignment($project_id: Int!, $level_ids: [Int!]!) {
        distributeAssignment(project_id: $project_id, level_ids: $level_ids) {
            user_id
            assignment_id
        }
    }
`;
